
import PxoSelectDemandModal     from "./PxoSelectDemandModal";
import { usePushNotifications } from "../../contexts/PushNotificationsContext";
import { useEffect, useState }  from "react";
import { usePxoPage }           from "../../contexts/PxoPageContext";
import api                      from "../../services/api";   

export default function PxoSelectDemandModalConteiner () {
    
    const { 

        isModalDemandOpen, 
        setModalDemandOpen, 
        selectedDate, 
        selectedHorizonTypeId, 
        pxoId 
    
    } = usePxoPage()

    const { setContentPushNotification } = usePushNotifications()

    const [ __demandData,           __setDemandData         ] = useState(null)
    const [ __selectedDemandPost,   __setSelectedDemandPost ] = useState({}) 


    const fetchDemandData = async () => {
        
        const response = await api.get(`/getDemandsForPxo?selectedDate=${selectedDate}&selectedHorizonTypeId=${selectedHorizonTypeId}`);   

        __setDemandData(response.data)

    }

    const handleSaveChanges = async () => {

        try {

            const demandPostArray = Object.entries(__selectedDemandPost).map(([key, value]) => ({
                railwayId: Number(key), 
                demandPostId: value
            }));

            const response = await api.put(`/insertDemandsInPxo/${pxoId}`, {
                selectedDemandPosts: demandPostArray
            })

            setContentPushNotification({
                title: 'Sucesso', 
                message: 'Demenadas inseridas com sucesso.'
            })

        } catch (error) {
            
            setContentPushNotification({
                title: 'Erro', 
                message: 'Erro ao salvar demandas.'
            });

        }
    }

    useEffect(() => {

        if (isModalDemandOpen && selectedDate && selectedHorizonTypeId) {
            fetchDemandData()
        }

    }, [isModalDemandOpen])


    const toogleSelectDemandForPxo = (railwayId, demandId, isTrue) => {
               
        if (isTrue) {

            //Add or update the selected demand post for the railway 
            __setSelectedDemandPost((prev) => ({
                ...prev,
                [railwayId]: demandId
            }))

        }else{

            //Remove the selected demand post for the railway
            __setSelectedDemandPost(prev => {
                const { [railwayId]: _, ...rest } = prev;
                return rest;
            });

        }
        
    }

    return(

        <PxoSelectDemandModal 
            

            isOpen={isModalDemandOpen} 
            onClose={() => {setModalDemandOpen(false)}} 
            onSubmit={handleSaveChanges} 
            demandData={__demandData}
            selectedDate={selectedDate}
            selectedHorizonTypeId={selectedHorizonTypeId}
            toogleSelectDemandForPxo={toogleSelectDemandForPxo}
            selectedDemandPost={__selectedDemandPost}

        />

    )
}